import { z } from 'zod';

/** Existing tenant-scoped numbering preview returned by GET /pos/ddt/sezionali. */
export const posDdtSezionaleSchema = z.object({
  id: z.string().min(1),
  codice: z.string(),
  nome: z.string().nullable(),
  is_default: z.boolean(),
  next_preview: z.string(),
});
export type PosDdtSezionale = z.infer<typeof posDdtSezionaleSchema>;
export const posDdtSezionaliResponseSchema = z.object({
  company_id: z.string().min(1),
  sezionali: z.array(posDdtSezionaleSchema),
});
export type PosDdtSezionaliResponse = z.infer<typeof posDdtSezionaliResponseSchema>;

/** Common SQL projection for contacts, companies and suppliers recipient search.
 * IDs remain varchar-compatible; supplier rows do not include source_table/SDI.
 * The canonical endpoint field is pec_email, not the old editor's local `pec`.
 */
export const posDdtRecipientSearchRowSchema = z.object({
  id: z.string().min(1),
  display_name: z.string(),
  source_table: z.string().nullish(),
  first_name: z.string().nullish(),
  last_name: z.string().nullish(),
  vat_number: z.string().nullish(),
  tax_code: z.string().nullish(),
  sdi_code: z.string().nullish(),
  pec_email: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  address: z.string().nullish(),
  city: z.string().nullish(),
  province: z.string().nullish(),
  postal_code: z.string().nullish(),
});
export type PosDdtRecipientSearchRow = z.infer<typeof posDdtRecipientSearchRowSchema>;
export const posDdtRecipientSearchResponseSchema = posDdtRecipientSearchRowSchema.array();
export type PosDdtRecipientSearchResponse = z.infer<typeof posDdtRecipientSearchResponseSchema>;